module.exports = __webpack_public_path__ + "static/media/ic_dropdown.13f732a0.svg";